"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApmRumLoggerServiceImpl = void 0;
const core_1 = require("@athena-portal/core");
const apm_rum_1 = require("@elastic/apm-rum");
/**
 * Implementation of the ILoggerService using the Elastic APM RUM library.
 * This service provides message logging.
 *
 * Please note that the Elastic APM RUM library is primarily designed
 * for capturing performance metrics and user interactions (transaction).
 * While this service enables logging arbitrary messages, it achieves this by
 * creating new transactions with the type "log-message" for each
 * message to be logged.
 */
let ApmRumLoggerServiceImpl = class ApmRumLoggerServiceImpl {
    constructor(apm) {
        this.apm = apm !== null && apm !== void 0 ? apm : this.apm;
    }
    /**
     * Log a message with optional contextual information.
     */
    log(message, context) {
        if (this.apm) {
            // start a new transaction with name = message and type = "log-message".
            const trx = this.apm.startTransaction(message /* trx name */, "log-message" /* trx type */);
            // if context entries are provided, add them to the transaction as labels
            context === null || context === void 0 ? void 0 : context.forEach(entry => {
                for (const key of Object.keys(entry)) {
                    const value = entry[key];
                    trx === null || trx === void 0 ? void 0 : trx.addLabels({
                        [key]: value
                    });
                }
            });
            // this workaround ensures that the transaction duration is at least 1 second
            // without this, transactions with very short durations are ignored
            trx === null || trx === void 0 ? void 0 : trx.end(trx._start + 1);
        }
    }
};
exports.ApmRumLoggerServiceImpl = ApmRumLoggerServiceImpl;
exports.ApmRumLoggerServiceImpl = ApmRumLoggerServiceImpl = __decorate([
    (0, core_1.injectable)(),
    __metadata("design:paramtypes", [apm_rum_1.ApmBase])
], ApmRumLoggerServiceImpl);
//# sourceMappingURL=ApmRumLoggerServiceImpl.js.map